import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class UserFileClobViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_FILE_CLOB_VIEW = '/api/user-file-clob-view';
        this.GET_FILTERED_LIST = '/list/filter';

        this.EXPORT_ZIP = '/export-zip';
    }

    async getFilteredList(filterBody) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.USER_FILE_CLOB_VIEW + this.GET_FILTERED_LIST;
            const filesList = await this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(filterBody)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return filesList;
        } catch (err) {
            console.log(err);
        }
    }

    async exportFilesToZip(filterBody) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.USER_FILE_CLOB_VIEW + this.EXPORT_ZIP;
            const filesList = await this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                        },
                    body: JSON.stringify(filterBody)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return filesList;
        } catch (err) {
            console.log(err);
        }
    }

}

export default UserFileClobViewService;